import { resolveMediaUrl } from "./mediaUrl";

/** Normalize string URLs or { url, caption, title, src } objects for HistoricalArchiveGallery. */
export function normalizeHistoricalGalleryItems(images) {
  const seen = new Set();
  const items = [];

  for (const raw of images || []) {
    let url = "";
    let caption = "";

    if (typeof raw === "string") {
      url = raw;
    } else if (raw && typeof raw === "object") {
      url = raw.url || raw.src || raw.image_url || "";
      caption = raw.caption || raw.title || "";
    } else {
      continue;
    }

    const resolved = resolveMediaUrl(url);
    if (!resolved || seen.has(resolved)) continue;
    seen.add(resolved);
    items.push({ url: resolved, caption: String(caption || "").trim() });
  }

  return items;
}

export function historicalGalleryUrls(items) {
  return normalizeHistoricalGalleryItems(items).map((item) => item.url);
}
